import * as React from "react";
import { TocList, ReportsList, ClientDetails } from "./clientNavList";
import "../../../assets/scss/components/header/client/clientNav.scss";
import {
	IClientProfilePicture,
	ICOMPersonalDetails,
	ICOMServicingDetails,
	IPersonalDetails,
	IServicingDetails
} from "../../types/components/login/userDetails";

export interface IUserNavProps {
	userDetails?: {
		clientPicture: IClientProfilePicture | undefined;
		personalDetails: ICOMPersonalDetails | IPersonalDetails | undefined;
		servicingDetails: IServicingDetails | ICOMServicingDetails | undefined;
	};
}

export function UserNav(props: IUserNavProps) {
	return (
		<>
			<TocList />
			<ReportsList />
			<ClientDetails userDeatils={props.userDetails} />
		</>
	);
}
